import React from "react"
import "./styles.scss"

/**
 * Minimal dancing dots placeholder that inherits surrounding text styles.
 */
const DancingDots = ({ label = "Loading..." }) => (
  <span className="dancing-dots-loader" aria-label={label} role="status">
    <span className="dots">
      <span />
      <span />
      <span />
    </span>
  </span>
)

export default DancingDots
